/**
 * Number of active facet values across every filter attribute (the Advanced Filters button's
 * count badge, TEC navbar redesign Phase 1): sums the length of every attribute's value array in
 * the filters object, including `exclude_*`/`only_*` attributes (a real, results-changing
 * filter) and `lastSeenMin` (the posted-date filter). Sort is never part of this object (it's
 * tracked separately via useSearchSort), so it's never counted, matching the spec's "posted-date
 * counts, sort does not".
 */
export function countAppliedFilterValues(filtersObj: Record<string, string[] | undefined> | null | undefined): number {
  if (!filtersObj || typeof filtersObj !== 'object') return 0;
  let count = 0;
  for (const values of Object.values(filtersObj)) {
    if (Array.isArray(values)) count += values.length;
  }
  return count;
}
